var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"guarantee"},[_c('div',{staticClass:"guarantee_box"},_vm._l((_vm.$route.query.type == 1
          ? _vm.TianyuanArr
          : _vm.floorArr),function(item,index){return _c('div',{key:index,staticClass:"guarantee_item"},[_c('div',{staticClass:"img"},[_c('img',{staticClass:"img_cover",attrs:{"src":item.img,"alt":""}})]),_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }